export default "__VITE_ASSET__BWrhHOMj__"